import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const listBrand = lazy(() => import('../../container/pages/Brands'));

function PagesRoute() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/listBrand`} component={listBrand} />
    </Switch>
  );
}

export default PagesRoute;
